import React from "react";

const DefaultComponent = () => {
  return (
    <div className="set-info roll">
      <div className="inner">
        <div className="set">
          <div className="op sound">
            <h3>사운드</h3>
            <input type="checkbox" name="" id="s-onoff" />
            <label htmlFor="s-onoff">
              <div className="icon-box"></div>
            </label>
            <label htmlFor="s-onoff">
              <div className="on-off">
                <em></em>
              </div>
            </label>
          </div>
          <div className="op voice">
            <h3>음성지원</h3>
            <input type="checkbox" name="" id="v-onoff" />
            <label htmlFor="v-onoff">
              <div className="icon-box"></div>
            </label>
            <label htmlFor="v-onoff">
              <div className="on-off">
                <em></em>
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefaultComponent;
